<template>
  <section class="nws">
    <div class="nws__container">
      <div class="nws__banner reveal">
        <!-- Décorations -->
        <div class="nws__deco nws__deco--blob" aria-hidden="true"></div>
        <div class="nws__deco nws__deco--ring" aria-hidden="true"></div>
        <div class="nws__deco nws__deco--dots" aria-hidden="true"></div>
        <div class="nws__deco nws__deco--paper" aria-hidden="true"></div>

        <div class="nws__content">
          <div class="nws__topline">
            <a class="nws__logo" href="https://www.221assurances.com" target="_blank" rel="noopener">
              <img src="../../../assets/img/logos_sn_221.png" alt="221assurances" loading="lazy" />
            </a>

          </div>

          <h2 class="nws__title">{{ $t('home_page.newsletter_title') }}</h2>
          <p class="nws__desc">{{ $t('home_page.newsletter_description') }}</p>

          <form class="nws__form" @submit.prevent="suscribeNewsletter221()">
            <input
              v-model="UserEmail"
              type="email"
              name="email"
              id="email_input"
              class="nws__input"
              :placeholder="$t('home_page.newsletter_input_placeholder')"
            />
            <button type="submit" class="nws__btn">
              {{ $t('home_page.newsletter_bouton') }} <i class="fas fa-paper-plane"></i>
            </button>
          </form>

          <div class="nws__meta">
            <span><i class="material-icons">verified_user</i>{{ $t('home_page.newsletter_trust') }}</span>
            <span><i class="material-icons">lock</i>{{ $t('home_page.newsletter_note') }}</span>
          </div>
        </div>

        <!-- Visuel mascotte -->
        <div class="nws__visual">
          <div class="nws__mascot-card">
            <span class="nws__mail-chip"><i class="material-icons">mail</i></span>
            <img
              src="../../../assets/img/home/new_home/Mascot_assuraf.png"
              alt="Kiray, la mascotte Assuraf"
              loading="lazy"
            />
            <span class="nws__star-chip"><i class="material-icons">star</i></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApiBrevo from '../../../services/ApiBrevo';

export default {
  name: 'newsletters_section',
  data: () => ({
    UserEmail: null,
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    ToastTabSucess: {
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'success',
      className: 'custom-success-class'
    },
    ToastTabError: {
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'error'
    },
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    suscribeNewsletter221() {
      if (this.UserEmail) {
        let newAbonne221 = {
          listIds: [23],
          email: this.UserEmail,
          updateEnabled: false
        }

        ApiBrevo().post('contacts', newAbonne221)
          .then(result => {
            if (result.status === 201) {
              this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
              this.UserEmail = ''
            }
          }).catch(() => {
            this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
          });
      } else {
        this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221 !", this.ToastTabError);
      }
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.nws {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #fff 0%, #FFFBF6 100%);

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__banner {
    position: relative;
    overflow: hidden;
    border-radius: 34px;
    background: linear-gradient(132deg, #ffb33d 0%, #ffa409 38%, #f57c00 100%);
    box-shadow: 0 44px 90px rgba(240, 136, 0, 0.35);
    padding: 64px 64px;
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    gap: 48px;
    align-items: center;
  }

  &__deco {
    position: absolute;
    pointer-events: none;

    &--blob {
      width: 400px;
      height: 400px;
      border-radius: 50%;
      background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.3), transparent 62%);
      top: -170px;
      left: -130px;
    }

    &--ring {
      width: 360px;
      height: 360px;
      border: 2px dashed rgba(255, 255, 255, 0.35);
      border-radius: 50%;
      top: -170px;
      right: -110px;
      animation: nws-spin 45s linear infinite;
    }

    &--dots {
      width: 220px;
      height: 220px;
      right: -40px;
      bottom: -40px;
      background-image: radial-gradient(rgba(255, 255, 255, 0.32) 2px, transparent 2px);
      background-size: 24px 24px;
      -webkit-mask-image: radial-gradient(circle at 100% 100%, #000 0%, transparent 72%);
      mask-image: radial-gradient(circle at 100% 100%, #000 0%, transparent 72%);
    }

    &--paper {
      width: 90px;
      height: 90px;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.14);
      border: 1px solid rgba(255, 255, 255, 0.28);
      transform: rotate(18deg);
      left: 46%;
      bottom: -46px;
    }
  }

  &__content {
    position: relative;
    z-index: 2;
  }

  &__topline {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 26px;
  }

  &__logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 14px 32px rgba(120, 60, 0, 0.28);
    overflow: hidden;
    transition: transform 0.3s ease;

    img {
      width: 36px;
      height: 36px;
      object-fit: contain;
    }

    &:hover {
      transform: translateY(-4px) rotate(-5deg);
    }
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 1px;
    padding: 8px 16px;
    border-radius: 999px;

    i {
      font-size: 16px;
    }
  }

  &__title {
    margin: 0 0 14px;
    font-size: clamp(34px, 4vw, 46px);
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -0.5px;
    color: #fff;
  }

  &__desc {
    margin: 0 0 34px;
    max-width: 480px;
    font-size: 17px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.92);
  }

  &__form {
    display: flex;
    gap: 12px;
    max-width: 520px;
    background: #fff;
    border-radius: 999px;
    padding: 8px 8px 8px 22px;
    box-shadow: 0 24px 50px rgba(120, 60, 0, 0.28);
    transition: box-shadow 0.3s ease, transform 0.3s ease;

    &:focus-within {
      transform: translateY(-2px);
      box-shadow: 0 30px 60px rgba(120, 60, 0, 0.36);
    }
  }

  &__input {
    flex: 1;
    min-width: 0;
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
    color: #2b2b2b;

    &::placeholder {
      color: #898d8f;
    }
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border: none;
    cursor: pointer;
    padding: 15px 26px;
    border-radius: 999px;
    background: #2b2b2b;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    transition: background 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;

    i {
      font-size: 13px;
    }

    &:hover {
      background: #3d7ba6;
      transform: translateY(-1px);
      box-shadow: 0 12px 26px rgba(0, 0, 0, 0.25);
    }
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 28px;
    margin-top: 28px;

    span {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.95);
    }

    i {
      font-size: 17px;
      color: #fff;
    }
  }

  &__visual {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
  }

  &__mascot-card {
    position: relative;
    width: 320px;
    max-width: 100%;
    aspect-ratio: 1;
    border-radius: 28px;
    background: #fff;
    box-shadow: 0 34px 70px rgba(120, 60, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 94%;
      height: 94%;
      object-fit: contain;
      filter: drop-shadow(0 24px 26px rgba(43, 43, 43, 0.25));
    }
  }

  &__mail-chip,
  &__star-chip {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 18px;
    box-shadow: 0 16px 34px rgba(43, 43, 43, 0.22);
    animation: nws-float 5s ease-in-out infinite;

    i {
      font-size: 24px;
      color: #fff;
    }
  }

  &__mail-chip {
    top: 18px;
    left: 18px;
    background: linear-gradient(135deg, #7db6d4 0%, #3d7ba6 100%);
  }

  &__star-chip {
    bottom: 20px;
    right: 18px;
    background: linear-gradient(135deg, #ffb33d 0%, #f57c00 100%);
    animation-delay: 1s;
  }
}

@keyframes nws-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes nws-float {
  0%, 100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@media (max-width: 991px) {
  .nws {
    padding: 72px 24px;

    &__banner {
      grid-template-columns: 1fr;
      gap: 40px;
      padding: 48px 40px;
    }

    &__visual {
      order: -1;
    }

    &__mascot-card {
      width: 240px;
    }
  }
}

@media (max-width: 600px) {
  .nws {
    padding: 56px 16px;

    &__banner {
      border-radius: 26px;
      padding: 36px 22px;
      gap: 32px;
    }

    &__title {
      font-size: 30px;
    }

    &__desc {
      font-size: 15px;
      margin-bottom: 26px;
    }

    &__form {
      flex-direction: column;
      border-radius: 22px;
      padding: 12px;
      gap: 10px;
    }

    &__input {
      padding: 14px 12px;
    }

    &__btn {
      width: 100%;
      justify-content: center;
    }

    &__meta {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    &__mascot-card {
      width: 190px;
    }
  }
}

</style>
